import { UserInfoResultDto } from '../../_models/user-info-result-dto';

export class UserDashboardProxyListResultDto {
    managementCompany: string;
    location: string;
    userId: string;
    name: string;
    title: string;

    static transform(userInfo: UserInfoResultDto): UserDashboardProxyListResultDto {
        const dto: UserDashboardProxyListResultDto = new UserDashboardProxyListResultDto();
        if (!!userInfo) {
            dto.userId = userInfo.userId;
            dto.managementCompany = userInfo.companyName;
            dto.name = userInfo.displayName;
        }
        return dto;
    }
}
